<template>
  <div>
    <v-layout column class="mt-2">
      <!-- <v-container> -->
      <v-flex xs12 mx-4 mb-5>
        <h2>Tags assigned to this artwork</h2>
        <v-flex v-for="c in ['cataloguing','concept','relation','private']" :key="c" subheading my-3> 
          <!-- <v-divider class="mb-4"></v-divider> -->
          <!-- <h3>{{c.name}}</h3> -->
          <h3 class="mb-2">{{c}}</h3>
          <v-chip
          v-for="t in artwork.tags"
          v-if="t.section == c" 
          :key="t.id"
          :color="t.color"
          @input="deleteTag(t.id)"
          close
          :disabled="!c_user.edit"
          >
          <span v-if="t.subcategory">{{ `${t.subcategory}::`  }}</span>
          <b>{{ t.name }}</b>
          <!-- <h3>{{t.section}}</h3> -->
          </v-chip
        >
        </v-flex>
        <v-divider></v-divider>
      </v-flex>

      <v-flex align="center" sm="6" mx-4 v-if="c_user.edit">
        <!-- <h2>Add tags to this artwork</h2>

        <v-autocomplete
          :filter="customFilter"
          multiple
          chips
          v-model="selected_tags_assign"
          :items="tags_local"
          :item-text="
            item =>
              `${item.name} / ${item.category ? item.category : 'General'}`
          "
          label="Click to select Tags "
          item-text="name"
          item-value="id"
          hint="Select tags to assign to selected artworks"
        >
          <template v-slot:prepend-inner>
            <v-icon class="ml-2" @click="showFilter = false">style</v-icon>
          </template>
          <template v-slot:item="data">
            <v-list-tile-content>
              <v-list-tile-title
                ><span class="mr-2 px-0" v-if="data.item.concept_tag == 1"
                  >&starf;</span
                >{{ data.item.name }}</v-list-tile-title
              >
              <v-list-tile-sub-title
                class="text-xs-right"
                v-html="data.item.category ? data.item.category : 'General'"
              ></v-list-tile-sub-title>
              <v-divider></v-divider>
            </v-list-tile-content>
          </template>
        </v-autocomplete> -->

        <!-- <v-autocomplete
          v-model="selected_tags_assign"
          :items="tags_local"
          label="Select tags… "
          item-text="name"
          item-value="id"
          multiple
          chips
          deletable-chips
        ></v-autocomplete> -->
        <!-- persistent-hint -->
        <!-- hint="Add tags to assign to selected artworks" -->
        <!-- <v-flex mt-1 right>
          <v-btn dark small @click="assignTagsToArtwork()"
            >Assign tags ({{ selected_tags_assign.length }}) to this
            artwork)</v-btn
          >
        </v-flex> -->
      </v-flex>
      <!-- </v-container> -->
      <!-- <v-card color="grey lighten-5" class="mb-5 px-3 pb-3"> -->
      <v-flex xs12 mx-3>
        <!-- <template>
          <v-combobox
            v-model="chips"
            :items="artwork.tags"
            label="Tags"
            chips
            clearable
            prepend-icon="filter_list"
            solo
            multiple
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :selected="data.selected"
                close
                @input="remove(data.item)"
              >
                <strong>{{ data.item }}</strong>&nbsp;
                <span>(interest)</span>
              </v-chip>
            </template>
          </v-combobox>
        </template>           -->
        <!-- <h4 class="title mb-2">Upload {{uploadCategory}} – 4 files uploaded -->
        <!-- </h4> -->
        <!-- <v-list>
          <v-list-group
            v-for="tc in artwork.tags" :key="tc.id"
            v-model="tc.active"
            no-action
            >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{ tc.name }} ({{ctags(tc.id).length}})</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile v-for="tag in ctags(tc.id)" :key="tag.id">
              <v-list-tile-content>
                <v-list-tile-title>{{ tag.name }}</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action v-if="c_user.delete_rights">
                <v-btn @click="delete_tag" icon ><v-icon>delete</v-icon></v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
        </v-list>           -->
        <!-- <v-list class="xs12">
          <v-list-tile v-for="tc in tag_categories" :key="tc.id">
            <v-list-tile-title>
              {{tc.name}} {{showTags[tc.id]}}
              <v-btn @click="showTags[tc.id]=!showTags[tc.id]" color="grey lighten-5" small icon class="right mt-0 mb-0">
                <v-icon v-if="!showTags[tc.id]" small>expand_more</v-icon>
                <v-icon v-if="showTags[tc.id]" small dark>expand_less</v-icon>
              </v-btn>test
              <ul class="xs12">
                <li v-for="tag in ctags(tc.id)" :key="tag.id">
                    {{tag.name}}
                </li>
              </ul>
            </v-list-tile-title v-if="c_user.delete_rights">
            <v-list-tile-action v-if="c_user.delete_rights">
              <v-btn @click="delete_tag" icon ><v-icon>delete</v-icon></v-btn>
            </v-list-tile-action>
          </v-list-tile>

        </v-list> -->
        <!-- <v-btn
          icon
          class="mt-0 mb-0 xs12"
          @click="showUpload = !showUpload"
          v-if="c_user.edit"
          ><v-icon>add</v-icon></v-btn
        > -->
        <v-flex v-if="showUpload">
          <v-text-field
            v-model="tag.title"
            class="ml-2"
            name="note"
            label="Note"
          ></v-text-field>
          <v-text-field
            v-model="tag.description"
            class="ml-2"
            name="description"
            label="Description"
          ></v-text-field>
          <!-- <v-btn icon class="left mr-0 pr-0" xs12 @click="dropzone.processQueue()"><v-icon>send</v-icon></v-btn> -->
          <v-btn @click="showUpload = !showUpload">save</v-btn>
          <v-btn @click="showUpload = !showUpload">cancel</v-btn>
        </v-flex>
      </v-flex>
      <!-- </v-card> -->
    </v-layout>
  </div>
</template>

<script>
// Array.prototype.contains = function(v) {
//   for (var i = 0; i < this.length; i++) {
//     if (this[i] === v) return true;
//   }
//   return false;
// };
import axios from 'axios'
export default {
  props: ['artwork'],
  data: () => ({
    selected_tags_assign: [],
    selected: [],
    showUpload: false,
    showTags: [false, false, false, false, false, false, false, false],
    show: false,
    tag_categories: [
      { id: 1, name: 'TBA21 Exhibition', color: 'red', position: 2 },
      { id: 2, name: 'TBA21 Production', color: 'green', position: 3 },
      { id: 3, name: 'FTB Sorting', color: 'blue', position: 1 },
      { id: 4, name: 'TBA21 Projects', color: 'yellow', position: 4 },
      { id: 5, name: 'TBA21 Events', color: 'pink', position: 5 },
      { id: 6, name: 'Exhibitions', color: 'grey', position: 6 },
      { id: 7, name: 'Institutions', color: 'purple', position: 7 }
    ],
    tag: {
      description: '',
      title: ''
    },
    tags_local: []
  }),
  created() {
    this.tags_local = Object.assign([], this.$store.state.tags)
  },
  methods: {
    customFilter(item, queryText, itemText) {
      const textOne = item.name
        .toLowerCase()
        .replace(/ /g, '_')
        .replace('...', '')
        .replace(/ /g, '_')
        .replace(/\//g, '_')
        .replace(/\(\//g, '_')
      const textTwo = item.category
        ? textOne +
          '_' +
          item.category
            .toLowerCase()
            .replace(/ /g, '_')
            .replace('...', '')
            .replace(/\//g, '_')
        : textOne
      const searchText = queryText.toLowerCase()
      // var setOfSearchStrings = queryText.split(' ');

      // for(var i = 0; i < setOfSearchStrings.length; i++){
      //   if(mainString.indexOf(setOfSearchStrings[i]) != -1)
      //       stringExists = true;
      // }
      // let re = new RegExp('^(?=.*\\b' + textOne + '\\b)(?=.*\\b' + textTwo + '\\b).*$')
      // var rer = re.exec(queryText)
      // return rer
      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      )
    },
    deleteTag(id) {
      this.$emit('showSnackbar', 'Deleting Tag from this Artwork…')
      let url = `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`
      axios
        .put(url, {
          // artwork: {
          tag_id: id,
          delete_tag: 1
          // }
        })
        .then(response => {
          this.errors = {}
          // this.selected_tags_assign = []
          this.artwork.tags = response.data
          this.$emit('showSnackbar', 'Tag Deleted from this Artwork.', 'green')
          // this.$store.commit('ADD_COST', response.data)
        })
        .catch(error => {
          this.errors = error.response.data
        })
    },
    assignTagsToArtwork() {
      this.$emit('showSnackbar', 'Saving Tags…')
      if (this.artwork.tags.length > 0) {
        var a = this.artwork.tags.map(t => t.id)
        var c = a.concat(this.selected_tags_assign)
        var d = c.filter(function(item, pos) {
          return c.indexOf(item) == pos
        })
      } else {
        var d = this.selected_tags_assign
      }
      if (!this.artwork.tags) {
        this.artwork.tags = []
      }
      let url = `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`
      axios
        .put(url, {
          artwork: {
            tags: d,
            save_tags: 1
          }
        })
        .then(response => {
          this.errors = {}
          this.selected_tags_assign = []
          this.artwork.tags = response.data
          this.$emit('showSnackbar', 'Tags saved.', 'green')
          // this.$store.commit('ADD_COST', response.data)
        })
        .catch(error => {
          this.errors = error.response.data
        })
      // this.tag = {
      //   description: '',
      //   title: ''
      // }
    },
    delete_tag() {},
    ctags(cid) {
      var tags = Object.assign([], this.$store.state.tags)
      var out = []
      // tags.forEach(tag => {
      out = tags.filter(function(t) {
        return cid == t.tag_category_id
      })
      // console.log(out)
      return out
    },
    assign_tag_colors() {
      // var stc = this.selected_tag_categories
      var tc = this.tag_categories
      var tags = Object.assign([], this.$store.state.tags)
      var out = []
      tags.forEach(tag => {
        var a = tc.filter(function(tagc) {
          return tagc.id == tag.tag_category_id
        })
        if (a[0]) {
          tag.color = a[0].color + 'a'
        }
        out.push(tag)
      })
      out = out.sort(function(a, b) {
        var nameA = a.name.toUpperCase() // ignore upper and lowercase
        var nameB = b.name.toUpperCase() // ignore upper and lowercase
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        return 0
      })
      // return out.filter(function(tag) { return stc.some(st => tag.tag_category_id==st)})
      return out
    }
  }
  // computed: {
  // categories() {
  //   var out = []
  //   out.push(this.artwork.tags[0].tag_category_id)
  //   for (var t in this.artwork.tags) {
  //     if (!out.contains(this.artwork.tags[t].tag_category_id)) {
  //       out.push(t)
  //     }
  //   }
  //   return out
  // },
  // }
}
</script>

<style scoped>
/* .card { min-width:250px;} */
</style>



// WEBPACK FOOTER //
// src/components/artworks/Tags.vue